<div class="navigation" *ngIf="navigation$ | async as navigation">
  <img class="logo"
       src="assets/icons/logo.svg"
       alt="Averia">

  <ng-container *ngFor="let group of navigation; index as i">
    <hr *ngIf="i !== 0">
    <ng-container *ngFor="let child of group.children; index as j">
      <a mat-icon-button
         class="navigation-link"
         [class.secondary-navigation]="i !== 0 || j >= 4"
         [attr.aria-label]="child.title"
         [matTooltip]="child.title"
         matTooltipPosition="after"
         [routerLink]="child.url"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{
           paths: child.url === '/' ? 'exact' : 'subset',
           queryParams: 'ignored',
           matrixParams: 'ignored',
           fragment: 'ignored'
         }"
         ariaCurrentWhenActive="page">
        <mat-icon [svgIcon]="child.svgIcon">{{child.icon}}</mat-icon>
        <span class="navigation-label">{{child.title}}</span>
      </a>
    </ng-container>
  </ng-container>

  <button mat-icon-button
          [matMenuTriggerFor]="rowOptions"
          aria-label="More navigation and account options"
          class="options">
    <mat-icon>more_horiz</mat-icon>
    <span class="navigation-label">More</span>
  </button>
  <mat-menu #rowOptions="matMenu">
      <ng-container *ngIf="isMobile$ | async">
        <ng-container *ngFor="let group of navigation; index as i">
          <ng-container *ngFor="let child of group.children; index as j">
            <a *ngIf="i !== 0 || j >= 4"
               mat-menu-item
               class="mobile-navigation-item"
               [routerLink]="child.url"
               routerLinkActive="active"
               ariaCurrentWhenActive="page">
              <mat-icon [svgIcon]="child.svgIcon">{{child.icon}}</mat-icon>
              <span>{{child.title}}</span>
            </a>
          </ng-container>
        </ng-container>
        <mat-divider class="mobile-navigation-item mobile-navigation-divider"></mat-divider>
      </ng-container>
      <button *ngIf="zonedTimeView$ | async as view"
              mat-menu-item
              (click)="switchZonedTime()">
        <mat-icon>language</mat-icon>
        Use {{(view == 'local' ? 'UTC' : 'Local')}} time
      </button>
      <button *ngIf="profile$ | async as profile"
              mat-menu-item
              (click)="signOut()">
        <mat-icon>exit_to_app</mat-icon>
        Sign out {{profile.nickname}}
      </button>
  </mat-menu>
</div>
